module.exports = {
  title: '档案审核',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-archives-audit',
    },
  },
};
